module.exports = "<div class=\"nn-plain-text container--large\"><div class=\"nn-plain-text__container container\"><div id=js-content class=_base-cms-html></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-modules/nn-plain-text/nn-plain-text.directive.html
// module id = 1006
// module chunks = 0